import { Alert, Alignment, Button, FormGroup, Icon } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { toast } from "react-toastify";
import { formatCnpj } from "../../utils";
import { Pager } from "../utils/Pager";
import { DateRangePicker90 } from "../utils/DateRangePicker90";
import moment from "moment";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { MemoriaStore } from "../../stores/memoria/MemoriaStore";

@observer
export class RelatorioMemoria extends React.Component<{}, {}> {

  obs = observable({
    date_periodo_relatorio: [] as any,
    selectEmpresa: newEmpresa() as IEmpresa,
    current_page: 1 as number,
    erros_relatorio: [] as any,
    relatorios: [] as any,
    selectedPeriodoRelatorio: [] as any,
    date1: "" as string,
    date2: "" as string,
    tarefas_page: 1 as number,
    modelo: "" as string,
    tipo: "" as string
  })

  constructor(props: any) {
    super(props);

    AppStore.setTitle("Relatório");

  }

  async componentDidMount(): Promise<void> {

    const dataInicio = moment().startOf("month").format("YYYY-MM-DD");
    const dataFim = moment().endOf("month").format("YYYY-MM-DD");

    this.obs.date1 = dataInicio;
    this.obs.date2 = dataFim;

    this.obs.selectedPeriodoRelatorio = [
      moment().startOf("month").toDate(),
      moment().endOf("month").toDate()
    ];

    this.obs.current_page = 1
    this.obs.selectEmpresa = newEmpresa()
    this.obs.modelo = ""
    this.obs.tipo = ""

    await MemoriaStore.handleTasksPaged(1, "", dataInicio, dataFim, "", "");

  }

  async handleChangePage(page: number) {
    this.obs.current_page = page
    await MemoriaStore.handleTasksPaged(this.obs.current_page, this.obs.selectEmpresa.cnpj, this.obs.date1, this.obs.date2, this.obs.modelo, this.obs.tipo);
  }

  handleDateSolicitacaoChange = (val: any) => {
    var string = val.toString();
    var array = string.split(",");

    MemoriaStore.obs.date_start = moment(array[0]).format("YYYY-MM-DD")
    MemoriaStore.obs.date_end = moment(array[1]).format("YYYY-MM-DD")

    this.obs.date_periodo_relatorio = val;

  };

  clearEmpresa = () => {
    this.obs.selectEmpresa = newEmpresa();
    this.handlePageChange()
  };

  handleErrosRelatorio(error: string) {
    let list_erros = error.split(",")
    this.obs.erros_relatorio = list_erros?.map(x => {
      return { "erros": x }
    })
    MemoriaStore.obs.open_erros_relatorio = true
  }

  onCloseErros() {
    MemoriaStore.obs.open_erros_relatorio = false
    this.obs.erros_relatorio = []
  }

  handlePageChange = async () => {

    if (!this.obs.selectedPeriodoRelatorio || this.obs.selectedPeriodoRelatorio.length < 2 || !moment(this.obs.selectedPeriodoRelatorio[0]).isValid() || !moment(this.obs.selectedPeriodoRelatorio[1]).isValid()) {
      toast.warning("Selecione o período.", {});
      return;
    }

    this.obs.tarefas_page = 1
    await MemoriaStore.handleTasksPaged(this.obs.tarefas_page, this.obs.selectEmpresa.cnpj, this.obs.date1, this.obs.date2, this.obs.modelo, this.obs.tipo);
  };

  handlePeriodoRelatorioChange = (val: any) => {
    this.obs.selectedPeriodoRelatorio = val;

    if (val && val.length >= 2) {
      this.obs.date1 = moment(val[0]).format("YYYY-MM-DD");
      this.obs.date2 = moment(val[1]).format("YYYY-MM-DD");
    } else {
      this.obs.date1 = "";
      this.obs.date2 = "";
    }

    this.handlePageChange()

  };

  render() {
    let items = MemoriaStore.obs.tasks_relatorio?.map(imp => {

      return ({
        id: imp._id,
        cnpj: imp.cnpj,
        razao_social: imp.razao_social,
        inserted_at: imp.inserted_at,
        status: imp.status,
        relatorio_id: imp.relatorio_id,
        error: imp.error,
        modelo: imp.modelo,
        tipo: imp.tipo,
        format: imp.format
      });

    });

    let empresaFiltroText = this.obs.selectEmpresa.cnpj != ""
      ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa";

    function statusFormatter(cell, row) {

      return getTag(row.status);

    }

    function fileFormatter(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 2}
            onClick={() => MemoriaStore.handleDownloadArquivoRelatorio(row.relatorio_id, row.cnpj, row.format)}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      );
    }

    const errosFormatter = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 3}
            onClick={() => this.handleErrosRelatorio(row.error)}
          >
            <img src="/images/view.png" />
          </MDBBtn>
        </>
      );
    }

    const dateFormatter = (cell, row) => {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
    };

    const cnpjFormatter = (cell, row) => {
      return formatCnpj(row.cnpj)
    };
    
    const stringFormatter = (cell, row) => {

      if (!cell) return ""

      return cell.toUpperCase()

    };

    return (
      <>

        <MDBRow>
          <MDBCol sm="12" md="6" lg="3" xl="3">
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => {
                  this.obs.selectEmpresa = e;
                  this.handlePageChange()
                }}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  className="filtroFullWidth"
                  text={empresaFiltroText}
                  alignText={Alignment.LEFT}
                  rightIcon={
                    this.obs.selectEmpresa?.cnpj ? (
                      <Icon
                        className="clear-icon-empresa"
                        icon="cross"
                        onClick={(ev) => {
                          ev.stopPropagation();
                          this.clearEmpresa();
                        }}
                      />
                    ) : (
                      <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                    )
                  }
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol sm="12" md="6" lg="2" xl="2">
            <FormGroup label="Período Agendamento" className="inputsPeriodoCalculos">
              <DateRangePicker90
                onChange={this.handlePeriodoRelatorioChange}
                value={this.obs.selectedPeriodoRelatorio} />
            </FormGroup>
          </MDBCol>

          <MDBCol xs="6" sm="6" md="4" lg="1" xl="1">
            <FormGroup label="Modelo">
              <select
                onChange={(e) => {
                  this.obs.modelo = e.target.value;
                  this.handlePageChange()
                }}
                value={this.obs.modelo}
                className="bp3-button bp3-align-left filtroFullWidth"
              >
                <option value="">Todos</option>
                <option value="nfe">NF-E</option>
                <option value="nfce">NFC-E</option>
                <option value="cte">CT-E</option>
                <option value="nfse">NFS-E</option>
              </select>
            </FormGroup>
          </MDBCol>

          <MDBCol xs="6" sm="6" md="4" lg="1" xl="1">
            <FormGroup label="Tipo">
              <select
                onChange={(e) => {
                  this.obs.tipo = e.target.value;
                  this.handlePageChange()
                }}
                value={this.obs.tipo}
                className="bp3-button bp3-align-left filtroFullWidth"
              >
                <option value="">Todos</option>
                <option value="entrada">Entrada</option>
                <option value="saida">Saída</option>
              </select>
            </FormGroup>
          </MDBCol>

          <MDBCol xs="12" sm="12" md="4" lg="1" xl="1" className="colBtnBuscar">
            <MDBBtn
              className="btnDefault btnBuscarNfe filtroFullWidth"
              onClick={() => this.handlePageChange()}
              style={{ marginTop: 26 }}
            >
              Buscar
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <div data-tut="table">
          <BootstrapTable className="TableDefault" ref="table" data={items}>
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="razao_social" width="30%">Razão Social</TableHeaderColumn>
            <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="20%">CNPJ</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data do Agendamento</TableHeaderColumn>
            <TableHeaderColumn dataFormat={stringFormatter} dataField="modelo" width="10%">Modelo</TableHeaderColumn>
            <TableHeaderColumn dataFormat={stringFormatter} dataField="tipo" width="10%">Tipo</TableHeaderColumn>
            <TableHeaderColumn dataField="status" dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={fileFormatter} width="10%">Arquivo</TableHeaderColumn>
            <TableHeaderColumn dataFormat={errosFormatter} width="10%">Erros</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.current_page}
            totalCount={MemoriaStore.obs.length_tasks_relatorio}
            pageSize={15}
            onPageChange={page => this.handleChangePage(page)}
          />
        </div>

        <Alert
          confirmButtonText="Fechar"
          isOpen={MemoriaStore.obs.open_erros_relatorio}
          onClose={() => this.onCloseErros()}
          onConfirm={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertErrorSped"
        >
          <h2 className="titleSEFAZ">Erros</h2>
          <MDBCol md="12">
            {this.obs.erros_relatorio.length &&
              <div className="errosSped">
                <BootstrapTable className="nomeArquivos" data={this.obs.erros_relatorio} hover>
                  <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                  <TableHeaderColumn dataField='erros' width='100%'></TableHeaderColumn>
                </BootstrapTable>
              </div>
            }
          </MDBCol>
        </Alert>

        <LoadingModal open={MemoriaStore.obs.loading} onClose={() => MemoriaStore.obs.loading = false} title={"Baixando arquivo"} />
      </>
    )
  }
}

export default RelatorioMemoria;
